module.exports = __webpack_public_path__ + "img/brand-logo.dd709903.svg";